import React from "react";

const Avatar = ({ user, inline = false }) => {
    const hasAvatar = user && user.avatar && user.avatar.trim().length > 0;
    if (!inline) {
        return (
            <div>
                {hasAvatar &&
                    <img
                        className="inline-block h-12 w-12 rounded-sm"
                        src={user.avatar}
                        alt=""
                    />
                }
                {!hasAvatar &&
                    <div className="flex items-center justify-center h-12 w-12 rounded-sm uppercase font-bold text-3xl font-sans"
                        style={{ backgroundColor: user.name_initials_bg_color, color: user.name_initials_text_color }}
                    >
                        {user.username[0]}
                    </div>
                }
            </div>
        );
    }

    return (
        <div>
            {hasAvatar &&
                <img
                    className="inline-block h-7 w-7 rounded-full"
                    src={user.avatar}
                    alt=""
                />
            }
            {!hasAvatar &&
                <div className="flex items-center justify-center h-7 w-7 rounded-full uppercase font-bold text-md font-sans"
                    style={{ backgroundColor: user?.name_initials_bg_color??"#e9d5ff", color: user?.name_initials_text_color??"#7e22ce" }}
                >
                    {user?.username[0]??"@"}
                </div>
            } 
        </div>
    );
};

export default Avatar;